import CryptoJS from "crypto-js";

export const getWalletFromIndexedDB = async (): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const indexedDB =
      window.indexedDB ||
      (window as any).mozIndexedDB ||
      (window as any).webkitIndexedDB ||
      (window as any).msIndexedDB ||
      (window as any).shimIndexedDB;

    const request = indexedDB.open("ec_wallets", 1);

    request.onerror = function (event) {
      console.log("error: ");
      // console.error(event);
    };

    request.onupgradeneeded = function (event) {
      const db = request.result;
      const store = db.createObjectStore("ec_wallets", {
        keyPath: "address",
      });
    };

    request.onsuccess = function (event) {
      const db = request.result;
      const tx = db.transaction("ec_wallets", "readwrite");
      const store = tx.objectStore("ec_wallets");
      const getRequest = store.getAll();

      getRequest.onerror = function (event) {
        console.log("error: ");
        // console.error(event);
      };

      getRequest.onsuccess = function (event) {
        // console.log("success");
        // console.log(getRequest.result);
        resolve(getRequest.result);
      };

      tx.oncomplete = function () {
        db.close();
      };
    };
  });
};

export function encryptPrivateKey(privateKey: string): string {
  const passphrase = process.env.REACT_APP_WALLET_ENCRYPTION_KEY as string; // Replace with your passphrase
  return CryptoJS.AES.encrypt(privateKey, passphrase).toString();
}

// Function to decrypt the private key
export function decryptPrivateKey(encryptedPrivateKey: string): string {
  const passphrase = process.env.REACT_APP_WALLET_ENCRYPTION_KEY as string; // Replace with your passphrase
  const bytes = CryptoJS.AES.decrypt(encryptedPrivateKey, passphrase);
  return bytes.toString(CryptoJS.enc.Utf8);
}
